import options from './thing-notes.component';

export default {
    selector: 'dtAsThingNotes',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-notes/index.js